<template>
  <v-navigation-drawer
    expand-on-hover
    color="primary"
    absolute
    permanent
    style="z-index: index 3"
  >
    <v-divider></v-divider>

    <v-list nav dense v-for="item in items" :key="item.id">
      <v-list-item link :to="item.router" exact>
        <v-list-item-icon>
          <v-icon color="white">{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-title style="color: white">
          {{ item.text }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          text: "Flujo de trabajo",
          icon: "fa-arrow-left",
          id: 4,
          router: `/FlujosTrabajo`,
        },
        {
          text: "Niveles",
          icon: "fa-layer-group",
          id: 0,
          router: `/FlujosTrabajo/def/niveles`,
        },
        {
          text: "Atributos",
          icon: "fa-clipboard-list",
          id: 1,
          router: `/FlujosTrabajo/def/atributos`,
        },
        {
          text: "Empleados",
          icon: "fa-users",
          id: 2,
          router: `/FlujosTrabajo/def/empleados`,
        },
        {
          text: "Filtros",
          icon: "fa-filter",
          id: 3,
          router: `/FlujosTrabajo/def/filtros`,
        },
        {
          text: "Procesos",
          icon: "fa-list-ol",
          id: 5,
          router: `/FlujosTrabajo/def/procesos`,
        },
      ],
    };
  },
};
</script>
